import { restClient } from '@/Core'

import { LETTER_REST_URL } from '../Contracts/ILetter'
import { LETTER_TAB_STATUSES } from '../Contracts/LetterStatus'

import type { ILetter, LetterCollectionResponse, LetterOwnerField } from '../Contracts/ILetter'

export interface LoadOwnerLettersParams {
    ownerField: LetterOwnerField
    ownerUuid: string
    page: number
    pageSize: number
}

/**
 * Листи власника для вкладки «Листи» (`SPEC-013` §9.2): сторінка спільної
 * колекції `GET /services/letters` з **обов'язковим** фільтром власника (без
 * нього бек віддає порожній список, §11) і префільтром статусів
 * «Відкладено · Відправлено · Не відправлено». Нові — першими.
 *
 * Клієнт бачить і листи своїх контактів і документів: їхній `client` — він
 * (§9.2, «Що показує»). Права рядка — `_permissions`.
 */
export const LoadOwnerLettersTask = async ({
    ownerField,
    ownerUuid,
    page,
    pageSize,
}: LoadOwnerLettersParams): Promise<{ items: ILetter[]; total: number }> => {
    const filters = {
        and: [
            { field: `${ownerField}.uuid`, op: '=', value: ownerUuid },
            { field: 'status', op: 'in', value: [...LETTER_TAB_STATUSES] },
        ],
    }

    const raw = await restClient.get(
        `${LETTER_REST_URL}?page=${page}&limit=${pageSize}&permissions=true&sort[createdAt]=desc&filters=${encodeURIComponent(
            JSON.stringify(filters)
        )}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as LetterCollectionResponse<ILetter> | ILetter[] | null
    const list = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])
    const items = Array.isArray(list) ? list.filter((item) => typeof item?.uuid === 'string') : []
    const total = !Array.isArray(data) && typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items, total }
}
